// @ts-ignore
import MIGRATOR_ABI from './migrator.json'

const MIGRATOR_ADDRESS = '0x16D4F26C15f3658ec65B1126ff27DD3dF2a2996b'

export { MIGRATOR_ADDRESS, MIGRATOR_ABI }
